import { useCallback, useEffect, useState } from 'react';
import { insights } from '../api-client/index';
export function useForecast() {
    const [forecast, setForecast] = useState({
        insufficientData: true,
        message: 'Loading…',
        updatedAt: '',
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await insights.forecast();
            setForecast(result);
        }
        catch {
            setError('Failed to load forecast');
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        void load();
    }, [load]);
    return { forecast, loading, error, load };
}
